import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, NavigationSkipped, Router, RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { filter, tap } from 'rxjs';
import { AccountSessionExpiredService } from '@app/core/libraries';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.css'],
    imports: [RouterModule, TranslatePipe, HeaderComponent, SidebarComponent],
    host: {
        '(document:keydown.escape)': 'close()',
        '[class.entering]': 'entrance',
    },

    providers: [AccountSessionExpiredService],
})
export class ShellComponent {
    readonly accountSessionExpiredService = inject(AccountSessionExpiredService);
    private readonly router = inject(Router);

    readonly menuOpen = signal(false);

    /** Arriving from the sign-in screen (a page load has no previous navigation): the sidebar and the sheet animate in. */
    readonly entrance = !!this.router.currentNavigation()?.previousNavigation;

    constructor() {
        this.router.events
            .pipe(
                filter((e) => e instanceof NavigationEnd || e instanceof NavigationSkipped),
                tap(() => this.close()),
                takeUntilDestroyed(),
            )
            .subscribe();
    }

    toggle(): void {
        this.menuOpen.update((open) => !open);
    }

    close(): void {
        this.menuOpen.set(false);
    }
}
